<template>
	<div class></div>
</template>

<script>
	export default {
		name: "",
		data() {
			return {};
		},
		methods: {
		 async	getWxLoginInfo(id) {
				  const {data:res}= await this.$api.getUserInfo()	
					//console.log(res)

				return
				this.$post("UserInfos").then((res) => {
					localStorage.setItem("user_name", res.data.nickname);
					localStorage.setItem("user_image", res.data.image);
					localStorage.setItem("user_vip", res.data.is_vip);
					this.$router.replace("/");
					this.$router.go(1);
				});
			},
		},
		created() {
			var full = this.$route.fullPath;
			var arr = full.split("=");
			var token = arr[1].split("&")[0];
			var is_mobile = arr[2];
			if (token) {
				localStorage.setItem("token", token);
				localStorage.setItem("user_id", token);
				this.getWxLoginInfo();
			} else {
				this.$router.replace("/");
				localStorage.setItem("isMobile", "1");
			}
		},
	};
</script>

<style scoped>
</style>
